import { Badge } from "@/components/ui/badge";

export default function PageHeader({ icon: Icon, eyebrow, title, description, actions, status }) {
  return (
    <div className="page-header">
      <div className="min-w-0">
        {eyebrow && <div className="page-eyebrow">{eyebrow}</div>}
        <div className="flex items-center gap-3">
          {Icon && <div className="page-icon"><Icon className="w-5 h-5" /></div>}
          <div className="min-w-0">
            <h1 className="page-title truncate">{title}</h1>
            {description && <p className="page-description">{description}</p>}
          </div>
          {status && <Badge variant="outline" className="hidden sm:inline-flex ml-2">{status}</Badge>}
        </div>
      </div>
      {actions && <div className="page-actions">{actions}</div>}
    </div>
  );
}
